function Component({ step = 1 }) {
  function renderColor(param) {
    switch (param) {
      case "active":
        return "w-6 h-6 rounded-full bg-primary-500 flex justify-center items-center mb-2"
      case "inactive":
        return "w-6 h-6 rounded-full border-dark flex justify-center items-center border text-dark-300 mb-2"
      case "textactive":
        return "mb-2 text-dark-100"
      case "textinactive":
        return "mb-2 text-dark-300"
      default:
        return ""
    }
  }
  return (
    <div>
      <div className="flex item-center justify-between text-xs text-center w-[93vw]">
        <div className="flex justify-start flex-col items-center">
          <div className={step === 1 ? renderColor("active") : renderColor("inactive")}>1</div>{" "}
          <div className={step === 1 ? renderColor("textactive") : renderColor("textinactive")}>Chọn gói cước</div>
        </div>
        <div className="flex justify-start flex-col items-center max-w-[150px] relative">
          <div
            className="absolute -left-8 top-3"
            style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8", width: "60px" }}
          ></div>
          <div className={step === 2 ? renderColor("active") : renderColor("inactive")}>2</div>{" "}
          <div className={step === 2 ? renderColor("textactive") : renderColor("textinactive")}>
            Chọn thời hạn và phương thức thanh toán
          </div>
          <div
            className="absolute -right-8 top-3"
            style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8", width: "60px" }}
          ></div>
        </div>
        <div className="flex justify-start flex-col items-center">
          <div className={step === 3 ? renderColor("active") : renderColor("inactive")}>3</div>{" "}
          <div className={step === 3 ? renderColor("textactive") : renderColor("textinactive")}>Thanh toán</div>
        </div>
      </div>
    </div>
  )
}
export default Component
